import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Btn = styled.button`
  display: block;
  width: ${(props) => (props.$inline ? "auto" : "100%")};
  padding: 14px 24px;
  margin-top: ${(props) => (props.$inline ? "0" : "24px")};
  background: var(--button-primary-color, #1D1D1F);
  color: #FFFFFF;
  border: 0;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0;
  cursor: pointer;
  white-space: nowrap;
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;

export default function FinalizeButton({ disabled, loading, onClick, label, inline }) {
  return (
    <Btn type="button" disabled={disabled || loading} onClick={onClick} $inline={inline}>
      {loading ? "FINALIZANDO..." : label}
    </Btn>
  );
}

FinalizeButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  inline: PropTypes.bool,
};

FinalizeButton.defaultProps = {
  label: "Finalizar compra",
};
